import React from 'react';
import { Box, Typography, Divider, List, ListItem, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import ClinicHeaderItem from './ClinicHeaderItem';
import { formatDateHour2 } from '../utils/lib';
import InventoryIcon from '@mui/icons-material/Inventory';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSnackbar } from '../providers/SnackBarProvider';
import { handleError } from '../utils/lib';
import { useTranslation } from 'react-i18next';

function RecipeItem({ recipe, onDelete, pet, canEdit, config }) {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const { t } = useTranslation();
  const [openConfirm, setOpenConfirm] = React.useState(false);

  const handleEdit = () => {
    const state = {
      updateRecipe: recipe,
      pet: pet,
    }

    //console.log(state);
    navigate('/main/edit-recipe', { state: state });
  }

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_API_URL}pets_recipes?id=${recipe.id}`,
        { withCredentials: true }
      );
      if (onDelete) {
        onDelete(recipe.id);
      }
    } catch (error) {
      handleError(error, snackbar);
    }
    setOpenConfirm(false);
  };

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const getTitle = () => {
    if (config?.vet?.id === recipe.vet.id) {
      return recipe.user.name;
    }
    return `${recipe.user.name} | ${recipe.vet.name}`;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mb: 2,
      }}
    >
      {/* Encabezado usando ClinicHeaderItem */}
      <ClinicHeaderItem 
        title={getTitle()}
        subtitle={formatDateHour2(recipe.date, config)}
        age={recipe.age}
        thumbUrl={recipe.user.thumb_url}
        onEdit={canEdit ? handleEdit : undefined}
        onDelete={canEdit ? handleOpenConfirm : undefined}
      />

      <Box sx={{ mt: 2 }}>
        {recipe.treatment && (
          <>
            <Typography variant="caption" sx={{ display: 'block' }}>
              {t('common.treatment')}
            </Typography>
            <Typography>
              {recipe.treatment.name}
            </Typography>
          </>
        )}

        {recipe.notes && (
          <>
            <Typography variant="caption" sx={{ mt: 2, display: 'block' }}>
              {t('common.notes')}
            </Typography>
            <Typography>
              {recipe.notes}
            </Typography>
          </>
        )}

        {recipe.items && recipe.items.length > 0 && (
          <>
            {/* <Typography variant="caption" sx={{ mt: 2, display: 'block' }}>
              Productos
            </Typography> */}
            <List dense>
              {recipe.items.map((item, index) => (
                <ListItem key={index} sx={{ py: 0.5 }}>
                  <ListItemText
                    primary={
                      <Box display="flex" alignItems="center">
                        <InventoryIcon sx={{ fontSize: 20, mr: 1 }} />
                        {item.product.name}
                      </Box>
                    }
                    secondary={`${t('layouts.dosePrefix')} ${item.dosage} | ${t('layouts.every')} ${item.every_hours} ${t('layouts.hours')}${item.total_days ? ` | ${t('layouts.totalDaysLabel')} ${item.total_days}` : ''}`}
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </Box>

      {/* Línea divisoria */}
      <Divider
        sx={{
          marginTop: 1,
          marginBottom: 1,
          backgroundColor: '#dadada',
          height: 1,
        }}
      />

      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
      >
        <DialogTitle>{t('common.confirmDeletion')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('layouts.confirmDeleteRecipe')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="primary">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDelete} color="error" autoFocus>
            {t('common.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>  
  );
}

export default RecipeItem; 